import { render, staticRenderFns } from "./logo.component.vue?vue&type=template&id=22220f04&scoped=true&"
import script from "./logo.component.vue?vue&type=script&lang=js&"
export * from "./logo.component.vue?vue&type=script&lang=js&"
import style0 from "./logo.component.vue?vue&type=style&index=0&id=22220f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22220f04",
  null
  
)

export default component.exports